export class ServerInfoDataForm {

    userToken : string;
	msgCode;
    message;
    serverDate : Date; // Date

    constructor() {
        
    }

}